<template>
  <div
    class="menu"
    :class="`menu--${type}`"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    props: {
      type: { type: String, default: 'horizontal' }
    }
  }
</script>


<style scoped lang="scss">
  .menu {
    $p: &;

    display: flex;
    padding: 1rem 0;

    & > * {
      text-align: left;
      &:not(:last-child) { 
        margin-right: 20px 
      }
    }

    &--vertical {
      flex-direction: column;

      // & > * {
      //   transition: .5s all;

      //   &:not(:last-child) {
      //     border-bottom: 1px solid lighten(#000, 90);
      //   }

      //   &:hover {
      //     transform: translateX(10px);
      //   }
      // }
    }
  }
</style>